// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"71":"8a054ed1","88":"2ceb8c31","255":"2150cb0b","298":"9748e742","404":"97a65a82","565":"63d5592d","757":"3b266769"}[chunkId] + ".chunk.js";
};